// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// Don't rename properties of classes as they are used in serialization/deserialization
export class WorkspaceInfoResult {
}
export class WorkspaceDataInfo {
    constructor() {
        this.ws_id = '';
        this.name = '';
        this.updateTimeSpan = 0;
    }
}
export class WorkspaceData {
}
